module.exports = __webpack_public_path__ + "static/media/checkbox-answer.6e80595a.svg";